<template lang="html">
  <div class="a-container" :class="{'dark':dark, 'full-height':fullHeight, 'without-glow': hideGlow}">
    <a :name="name"></a>
    <div v-if="!hideLayout" class="container-borders d-none d-sm-none d-md-block" />
    <div class="container-content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    dark: {
      type: Boolean,
      default: false
    },
    fullHeight: {
      type: Boolean,
      default: false
    },
    hideGlow: {
      type: Boolean,
      default: false
    },
    hideLayout: {
      type: Boolean,
      default: false
    },
    name: {
      task: String
    }
  }
}
</script>

<style lang="css" scoped>
  .container-borders:before {
    z-index: 0;
    content: '';
    position: absolute;
    width: 40%;
    left: 10%;
    height: 100%;
    border: 1px solid #2F2A38;
    border-top: 0;
    border-bottom: 0;
  }
  .container-borders:after {
    content: '';
    position: absolute;
    height: 100%;
    top: 0;
    right: 10%;
    border-right: 1px solid #2F2A38;
    border-top: 0;
    border-bottom: 0;
  }
  .a-container {
    position: relative;
    /* border: 1px solid red; */
  }
  .container-content {
    /* padding-top: 80px; */
    position: relative;
    z-index: 1;
  }
  .container-content div {
  }
  .full-height {
    height: 100vh;
    /* max-height: 70vw; */
  }
  .full-height .a-container {
    /* padding-top: 80px; */
  }
  .without-glow {
    background-color: #18171a;
    z-index: 10;
  }
  .dark {
    background-color: #09090a;
  }
</style>
